import { filter } from "lodash";
import { Icon } from "@iconify/react";
import { Fragment, useEffect, useState } from "react";
import plusFill from "@iconify/icons-eva/plus-fill";
import iconEdit from "@iconify/icons-eva/edit-2-fill";
import iconArrowRight from "@iconify/icons-eva/arrow-ios-forward-fill";
import iconDelete from "@iconify/icons-eva/person-delete-fill";
import { Link, useNavigate } from "react-router-dom";
import moment from "moment";
// material
import { Card, Table, Stack, Switch,FormControl,InputLabel,Select,MenuItem, Button, TextField, TableRow,Grid, TableBody, TableCell, Container, Typography, TableContainer, TablePagination, RadioGroup, Radio, FormControlLabel, IconButton } from "@mui/material";
// components
import Page from "src/components/Page";
import Scrollbar from "src/components/Scrollbar";
import SearchNotFound from "src/components/SearchNotFound";
import UserInfo from "src/components/common/UserInfo";
import UserPicker from "src/components/common/UserPicker";
// import USERLIST from '../_mocks_/user';

import axios from "axios";
import MoreMenu from "src/components/common/MoreMenu";
import FormDialog from "src/components/common/FormDialog";
import FormItem from "src/components/form-item/FormItem";
import { alert } from "src/services/alert";
import Confirm from "src/components/common/ConfirmDialog";
import { ArrowRight } from "@mui/icons-material";
import ListHead from "src/components/common/ListHead";
import { useSelector } from "react-redux";
// import { getProductCategories } from "src/services/request";
import Uploader from "src/components/uploader/Uploader";
import CellImage from "src/components/common/CellImage";
import ListToolbar from "src/components/common/ListToolbar";
import MyDateRangePicker from "src/components/common/my-date-range-picker/MyDateRangePicker";
// import { setAreas, setMerchantProductCategories, setMerchantProductCategoryHierarchy, setProductCategories, setProductCategoryHierarchy, setMerchantCategories, setSystemMenus, setStoreSections, setStoreBrands, setSuppliers } from "../store/reducers/globalData";
import { setAreas, setMerchantProductCategories, setMerchantProductCategoryHierarchy, setProductCategories, setProductCategoryHierarchy, setMerchantCategories, setSystemMenus, setStoreSections, setStoreBrands, setSuppliers } from "../../store/reducers/globalData";

import { store } from "../../store";
const affiliatedGroup = [{
  name:'客服组',
  value:1
},{
  name:'综合组',
  value:2
},{
  name:'市场组',
  value:3
}];
const disableList = [{
  name:'是',
  value:1
},{
  name:'否',
  value:2
}];
const typeList = [{
  name:'消费券',
  value:1
},{
  name:'兑换券',
  value:2
},{
  name:'绿积分',
  value:3
}];
const TABLE_HEAD = [
  { id: "uid", label: "分组名称", alignRight: false },
  { id: "icon", label: "用户信息", alignRight: false },
  // { id: "sort", label: "排序", alignRight: false },
  { id: "order", label: "消费券", alignRight: false },
  { id: "dhq", label: "兑换券", alignRight: false },
  { id: "green", label: "绿积分", alignRight: false },
  // { id: "isShow", label: "是否禁用", alignRight: false },
  { id: "remark", label: "备注", alignRight: false },
  { id: "create", label: "最新时间", alignRight: false },
  { id: "operation", label: "操作", alignRight: false }
];

const moreMenus = [
  { title: "添加组员", icon: plusFill },
  { title: "拨付", icon: iconEdit },
  // { title: "编辑", icon: iconEdit },
  // { title: "删除", icon: iconDelete },
];
const moreMenusTwo = [
  // { title: "拨付", icon: iconEdit },
  // { title: "编辑", icon: iconEdit },
  { title: "删除", icon: iconDelete },
];

export default function ProductCategory() {
  const productCategories = useSelector((state) => state.globalData.productCategories);
  const navigate = useNavigate();
  const [items, setItems] = useState([]);
  const [itemsObj, setItemsObj] = useState({});
  const [menus, setMenus] = useState([]);
  const [foldMap, setFoldMap] = useState({});
  const [parent, setParent] = useState({});
  const [action, setAction] = useState("");
  const [targetItem, setTargetItem] = useState({});
  const [form, setForm] = useState({
    // icon: "",
    // 分组名
    name: "",
    // 是否禁用
    disabled: false,
    order: 0,
    // 类型
    type:null,
    // 金额
    amount:null,
    // 是否显示
    isShow: true,
    groupId: '',
    uid: '',
    showName: '',
    mobile: '',
    remark: '',
    pid: 0,
    pName: "",
  });
  const [filter, setFilter] = useState({
    page: 0,
    size: 10,
    // 用户id
    uid: null,
    // 昵称
    orderSN: null,
    // 手机号
    telephone: null,
    // 类型
    type:-1,
    // 是否禁用
    disabled: -1,
    createdAt: null
  });

  useEffect(() => {
    getProductCategories()
  }, [filter]);
  useEffect(() => {
    if (!productCategories || productCategories.length === 0) return;
    const menus = JSON.parse(JSON.stringify(productCategories));
    menus.sort((a, b) => b.orderNo - a.orderNo);
    const levels = [];

    for (let i = 0; i < menus.length; i++) {
      const level = (menus[i].level || 1) - 1;
      if (!levels[level]) {
        levels[level] = [];
      }

      levels[level].push(menus[i]);
    }

    for (let i = levels.length - 1; i > 0; i--) {
      for (let j = 0; j < levels[i].length; j++) {
        const parentGroup = levels[i - 1];
        const parent = parentGroup.find((p) => p.id === levels[i][j].pid);
        if (!parent) continue;

        if (!parent.children) {
          parent.children = [];
        }

        parent.children.push(levels[i][j]);
      }
    }
    // console.log('levels[0]: ', levels[0]);
    setItems(levels[0]);
    setMenus(menus);
  }, [productCategories]);

  function handleAddMenu(uid = 0, pName = "顶级") {
    setForm({
      icon: "",
      name: "",
      order: "",
      isShow: true,
      uid,
      pName,
      disabled: false,
    });
    setAction("addTop");
  }
  function handleAddMenuNew(row) {
    console.log('row: ', row);
    setForm({
      icon: "",
      name: "",
      order: "",
      isShow: true,
      uid: row.id,
      pName: row.name,
      disabled: false,
    });
    setAction("grouping");
  }
  // 拨付
  function handlePay(id, name) {
    setForm({
      name,
    });
    setAction("pay");
  }
  // 商品分类
  function getProductCategories(force = false){
    // if (store.getState().globalData.productCategories && !force) return;

    axios
      .post("/system/group/list", {
        // uid: filter.uid,
        // orderSN: filter.orderSN,
        // telephone: filter.telephone,
        // type: filter.type,
        // disabled: filter.disabled,
        // createdAt: filter.createdAt,
        page:0,
        size:100,
    })
      .then((res) => {
        const { code, msg, data } = res.data;
        if (code === 1) {
          store.dispatch(setProductCategories(data));
          const menus = JSON.parse(JSON.stringify(data));
          menus.sort((a, b) => b.orderNo - a.orderNo);
          const levels = [];

          for (let i = 0; i < menus.length; i++) {
            const level = (menus[i].level || 1) - 1;
            if (!levels[level]) {
              levels[level] = [];
            }

            levels[level].push(menus[i]);
          }

          for (let i = levels.length - 1; i > 0; i--) {
            for (let j = 0; j < levels[i].length; j++) {
              const parentGroup = levels[i - 1];
              const parent = parentGroup.find((p) => p.id === levels[i][j].pid);

              if (!parent.children) {
                parent.children = [];
              }

              parent.children.push(levels[i][j]);
            }
          }
          setItems(levels[0]);
          setMenus(menus);
          store.dispatch(setProductCategoryHierarchy(levels[0]));
        } else {
          alert(msg);
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  };
  function handlePickUser() {
      UserPicker({
        onSelect(v) {
          setParent(v);
        },
      });
  }
  const handleMoreClick = (type, row) => {
    setItemsObj(row);
    // console.log('row: ', row);
    if (type === "编辑") {
      let uid = 0;
      let pName = "顶级";
      if (row.uid) {
        const parent = menus.find((m) => m.id === row.uid);
        uid = parent.id;
        pName = parent.name;
      }

      setTargetItem({ ...row });
      if(row.level === 1){
        setAction("edit");
      }else{
        setAction("edit2");
      }
      setForm({
        isShow: row.isShow,
        icon: row.icon,
        order: row.order,
        name: row.name,
        uid,
        pName,
        disabled: row.isShow,
      });
    } else if (type === "删除") {
      handleDelBanner(row);
    } else if (type === "添加组员") {
      handleAddMenuNew(row);
      setAction("add");
    } else if (type === "拨付") {
      let uid = 0;
      let pName = "顶级";
      if(row.level === 1){
        if (row.uid) {
          const parent = menus.find((m) => m.id === row.uid);
          uid = parent.id;
          pName = parent.name;
        }
        setTargetItem({ ...row });
        setAction("pay");
      }else{
        if (row.uid) {
          const parent = menus.find((m) => m.id === row.pid);
          uid = parent.id;
          pName = parent.name;
        }
        setTargetItem({ ...row });
        setAction("pay2");
      }
      setForm({
        isShow: row.isShow,
        order: row.order,
        name: row.name,
        type: row.type,
        amount: row.amount,
        uid: row.uid,
        pName: pName,
        disabled: row.isShow,
      });
    }
  };

  function handleDelBanner(row) {
    console.log('row: ', row);
    let param={
      groupId: row.groupId,
      uid: row.uid,
    }
    Confirm({
      message: "删除不可恢复，确定删除吗?",
      onConfirm() {
        axios
          .post("/system/group/member/remove", param)
          .then((res) => {
            const { code, msg, data } = res.data;
            if (code === 1) {
              getProductCategories(true);
              setAction("");
              alert(msg, 'success');
            } else {
              alert(msg);
            }
          })
          .catch((err) => {
            console.log("删除分类失败: ", err);
          });
      },
    });
  }

  function handleIptChange(ki, val) {
    setForm({
      ...form,
      [ki]: val,
    });
  }

 function handleDialogConfirm() {
    let formData= {}
    // if (action === "edit") {
    //   formData.id = targetItem.id;
    // }
    // console.log(form)
    // console.log(itemsObj)
    // console.log(parent)
    // console.log(formData)

    if(action === "add"){
      formData = { ...form,
        groupId:itemsObj.id,
        uid:parent.uid || '',
        showName:parent.nickname || '',
        mobile:parent.mobile || '',
      };
        axios
      .post("/system/group/member/add", formData)
      .then((res) => {
        const { code, msg, data } = res.data;
        if (code === 1) {
          getProductCategories(true);
          setAction("");
          alert(msg, 'success');
        } else {
          alert(msg);
        }
      })
      .catch((err) => {
        console.log("添加组员失败: ", err);
      });
    }else if(action === "pay"){
      if(form.type == null){
        alert('请选择类型');
        return;
      }
      if(form.amount == null || form.amount <=0){
        alert(form.type == 1 ? '请输入金额':'请输入数量');
        return;
      }
      formData = { ...form,
        groupId:itemsObj.id,
        xfqAmount: form.type == 1 ? form.amount : null,
        dhqAmount: form.type == 2 ? form.amount : null,
        pointsAmount: form.type == 3 ? form.amount : null,
      };
        axios
      .post("/system/group/allocate", formData)
      .then((res) => {
        const { code, msg, data } = res.data;
        if (code === 1) {
          getProductCategories(true);
          setAction("");
          alert(msg, 'success');
        } else {
          alert(msg);
        }
      })
      .catch((err) => {
        console.log("拨付失败", err);
      });
    }else if(action === "pay2"){
      // console.log(form)
      // console.log(6666)
      // console.log(form.type)
      // if(form.type == null){
      //   alert('请选择类型');
      //   return;
      // }
      // if(form.amount == null || form.amount <=0){
      //   alert(form.type == 1 ? '请输入金额':'请输入数量');
      //   return;
      // }
      // formData = { ...form,
      //   groupId:itemsObj.id,
      //   xfqAmount: form.type == 1 ? form.amount : null,
      //   dhqAmount: form.type == 2 ? form.amount : null,
      //   pointsAmount: form.type == 3 ? form.amount : null,
      // };
      // console.log(formData)
      //   axios
      // .post("/system/group/allocate", formData)
      // .then((res) => {
      //   const { code, msg, data } = res.data;
      //   if (code === 1) {
      //     getProductCategories(true);
      //     setAction("");
      //     alert(msg, 'success');
      //   } else {
      //     alert(msg);
      //   }
      // })
      // .catch((err) => {
      //   console.log("拨付失败", err);
      // });
    }
    //
    //   axios
    //   .post(action === "add" ? "/store/category/add" : "/store/category/edit", formData)
    //   .then((res) => {
    //     const { code, msg, data } = res.data;
    //     if (code === 1) {
    //       getProductCategories(true);
    //       setAction("");
    //     } else {
    //       alert(msg);
    //     }
    //   })
    //   .catch((err) => {
    //     console.log("添加或修改分类失败: ", err);
    //   });
  }
  function handleFolding(row) {
    // console.log(77777)
    // console.log(row)
    setFoldMap({
      ...foldMap,
      [row.id]: !foldMap[row.id],
    });
  }

  const isUserNotFound = items.length === 0;

  function renderTableRow(list) {
  if (!list) return null;
  return list.map((row) => {
    const { id, name, remark, order, level, updatedAt, uid, children, info } = row;

    return (
      <Fragment key={id}>
        <TableRow hover tabIndex={-1}>
          <TableCell align="left" sx={{ pl: (level - 1) * 4 }}>
            <IconButton
              onClick={() => handleFolding(row)}
              disabled={!children || children.length === 0}
            >
              <ArrowRight
                sx={{
                  visibility: (!children || children.length === 0) ? "hidden" : "visible",
                  transform: `rotate(${foldMap[id] ? 90 : 0}deg)`
                }}
              />
            </IconButton>
            {name}
          </TableCell>
          <TableCell align="left">
            <Stack>
            {info && info.uid && (
              <>
                {/* <CellImage src={info.avatar} /> */}
                <Typography>用户ID：{info.uid}</Typography>
                <Typography>用户昵称：{info.nickname}</Typography>
                <Typography>用户手机号：{info.mobile}</Typography>
              </>
            )}
            </Stack>
          </TableCell>
          {/* <TableCell align="left">{order}排序</TableCell> */}
          <TableCell align="left">
            {info && info.uid && (
              <>
              {info.xfqV2}
              </>
            )}
            </TableCell>
          <TableCell align="left">
            {info && info.uid && (
              <>
              {info.dhqV2}
              </>
            )}
          </TableCell>
          <TableCell align="left">
            {info && info.uid && (
              <>
              {info.pointsV2}
              </>
            )}
          </TableCell>
          <TableCell align="left">备注：{remark}</TableCell>
          <TableCell align="left">{moment(updatedAt).format("YYYY-MM-DD HH:mm:ss")}</TableCell>
          <TableCell align="right">
            {row.level === 1 && (
              <MoreMenu spread menus={moreMenus} onMoreClick={(type) => handleMoreClick(type, row)} />
            )}
            {row.level === 2 && (
              <MoreMenu spread menus={moreMenusTwo} onMoreClick={(type) => handleMoreClick(type, row)} />
            )}
          </TableCell>
        </TableRow>
        {/* 只有当当前节点展开时才显示子节点 */}
        {foldMap[id] && renderTableRow(children)}
      </Fragment>
    );
  });
}
  const handleFilterByName = (event) => {
    setFilter({
      ...filter,
      search: event.target.value,
    });
  }
  function handleFilterChange(ki, val) {
    setFilter({
      ...filter,
      [ki]: val,
    });
  }
  function handleReset() {
    setFilter({
      page: 0,
      size: 10,
      uid: '',
      orderSN: '',
      telephone: '',
      type: -1,
      disabled: -1,
      createdAt: null
    })
  }

  return (
    <Page title="星巴克">
      <Container maxWidth="2000px">
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            星巴克分类
          </Typography>

          {/* <Button variant="contained" to="add" startIcon={<Icon icon={plusFill} />} onClick={() => handleAddMenu()}>
            添加分组
          </Button> */}
        </Stack>
        <Card>
          <ListToolbar showSearch={false}  onReset={handleReset} onRefresh={getProductCategories}>
            <Grid container rowGap={2}>
              {/* <Grid item lg={6} sm={6} md={3}>
                <MyDateRangePicker
                  value={filter.createdAt}
                  onChange={(val) => {
                    setFilter({
                      ...filter,
                      createdAt: val,
                    });
                  }}
                />
              </Grid> */}
              <Grid item sm={6} md={3}>
                <TextField
                  size="small"
                  style={{ width: 200 }}
                  label="用户ID"
                  placeholder="用户ID"
                  autoComplete="off"
                  id="uid"
                  value={filter.uid}
                  onChange={(e) => {
                    handleFilterChange("uid", e.target.value);
                  }}
                />

              </Grid>
              <Grid item sm={6} md={3}>
                <TextField
                  size="small"
                  style={{ width: 200 }}
                  label="昵称"
                  placeholder="昵称"
                  autoComplete="off"
                  id="orderSN"
                  value={filter.orderSN}
                  onChange={(e) => {
                    handleFilterChange("orderSN", e.target.value);
                  }}
                />
              </Grid>
              <Grid item sm={6} md={3}>
                <TextField
                  size="small"
                  style={{ width: 200 }}
                  label="手机号"
                  placeholder="手机号"
                  autoComplete="off"
                  id="telephone"
                  value={filter.telephone}
                  onChange={(e) => {
                    handleFilterChange("telephone", e.target.value);
                  }}
                />
              </Grid>
              {/* <Grid item sm={6} md={3}>
                <FormControl
                  size="small">
                  <InputLabel>所属组</InputLabel>
                  <Select
                    label="所属组"
                    value={filter.type}
                    onChange={(e) => {
                      console.log("所属组", e.target.value)
                      setFilter({
                        ...filter,
                        type: e.target.value,
                      });
                    }}
                    style={{ width: 250 }}
                  >
                    {[-1, ...affiliatedGroup].map((type, idx) => (
                      <MenuItem key={idx} value={type.value} name={type.name}>
                        {idx == 0 ? "全部" : type.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid> */}
              <Grid item sm={6} md={3}>
                <FormControl
                  size="small">
                  <InputLabel>是否禁用</InputLabel>
                  <Select
                    label="是否禁用"
                    value={filter.disabled}
                    onChange={(e) => {
                      console.log("是否禁用", e.target.value)
                      setFilter({
                        ...filter,
                        disabled: e.target.value,
                      });
                    }}
                    style={{ width: 250 }}
                  >
                    {[-1,...disableList].map((type, idx) => (
                      <MenuItem key={idx} value={type.value} name={type.name}>
                        {idx == 0 ? "全部" :type.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
          </ListToolbar>
        </Card>
        <Card>
          <Scrollbar>
            <TableContainer sx={{ minWidth: 800 }}>
              <Table>
                <ListHead headLabel={TABLE_HEAD} rowCount={items.length} />

                <TableBody>{renderTableRow(items)}</TableBody>
                {isUserNotFound && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                        {/* <SearchNotFound searchQuery={filterName} /> */}
                        <SearchNotFound />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </Scrollbar>
        </Card>
      </Container>

      <FormDialog title={action ==="addTop" ? "添加分组" :action === "add"||action === "grouping" ? "添加组员" : action === "pay"||action === "pay2" ? "拨付" : "编辑分组"} open={!!action} onClose={() => setAction()} onConfirm={handleDialogConfirm}>
        {action == "add" && (
          <FormItem title="父级分类">
            <TextField fullWidth placeholder="父级分类" autoComplete="off" id="pName" value={form.pName} size="small" disabled />
          </FormItem>
        )}
        {(action == "addTop" ||action == "pay" || action == "edit") && (
          <FormItem title={action === "addTop"||action === "edit" ? "分组名":action === "add" ? "组员":'父级分类'} required={(action != "pay"&&action != "pay2")}>
            <TextField fullWidth placeholder={action === "addTop"||action === "edit" ? "分组名":action === "add" ? "组员":'分组名'} autoComplete="off" id="name" value={form.name} disabled={action === "pay"} size="small" onChange={(e) => handleIptChange("name", e.target.value)} />
          </FormItem>
        )}
        {(action == "add") && (
          <FormItem title={action === "addTop"||action === "edit" ? "分组名":action === "add" ? "组员":'分组名'} required={action != "pay"}>
            <Stack onClick={handlePickUser}>
              <UserInfo {...parent} enablePreview={false} />
            </Stack>
            {/* <TextField fullWidth placeholder={action === "addTop"||action === "edit" ? "分组名":action === "add" ? "组员":'分组名'} autoComplete="off" id="name" value={form.name} disabled={action === "pay"} size="small" onChange={(e) => handleIptChange("name", e.target.value)} /> */}
          </FormItem>
        )}
        {(action == "edit2"|| action == "pay2") && (
          <FormItem title={action === "pay2"||action === "edit2" ? "组员":'分组名'} required={action != "pay2"}>
            {/* <Stack onClick={handlePickUser}>
              <UserInfo {...parent} enablePreview={false} />
            </Stack> */}
            <TextField fullWidth placeholder={action === "edit2"||action === "pay2" ? "组员":'分组名'} autoComplete="off" id="name" value={form.name} disabled={action === "pay2"} size="small" onChange={(e) => handleIptChange("name", e.target.value)} />
          </FormItem>
        )}
        {/* {(action != "add" && action != "edit") && (
          <FormItem title={action === "add" ? "分组名" : "组员"} required={action != "pay"}>
            <TextField fullWidth placeholder={action === "add" ? "分组名" : "组员"} autoComplete="off" id="name" value={form.name} disabled={action === "pay"} size="small" onChange={(e) => handleIptChange("name", e.target.value)} />
          </FormItem>
        )} */}
        {/* <FormItem title="分类图标">
          <Stack direction="row">
            <Uploader images={form.icon} onUploaded={v => handleIptChange('icon', v)} />
          </Stack>
        </FormItem> */}

        {(action === "pay"|| action == "pay2") && (
          <FormItem title="类型" required>
            {/* <Stack direction="row">
              {form.disabled}88888
            </Stack>
            <Stack direction="row">
              <Switch checked={form.disabled}  onChange={e => handleIptChange("disabled", e.target.checked)} />
            </Stack> */}
            <FormControl
            size="small">
            <InputLabel>选择类型</InputLabel>
            <Select
              label="选择类型"
              value={form.type}
              onChange={(e) => {
                setForm({
                  ...form,
                  type: e.target.value,
                });
              }}
              style={{ width: 250 }}
            >
              {[...typeList].map((type, idx) => (
                <MenuItem key={idx} value={type.value} name={type.name}>
                  {type.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          </FormItem>
        )}
        {(action === "pay"|| action == "pay2") && (
          <FormItem title={form.type == 1 ? "金额":"数量"} required>
            <TextField fullWidth placeholder={form.type == 1 ? "请输入金额":"请输入数量"} autoComplete="off" id="amount" value={form.amount} size="small" onChange={(e) => handleIptChange("amount", e.target.value)} />
          </FormItem>
        )}
        {/* <FormItem title="是否禁用" required>
          <Stack direction="row">
            <Switch checked={form.disabled}  onChange={e => handleIptChange("disabled", e.target.checked)} />
          </Stack>
        </FormItem> */}
        {/* <FormItem title="备注" required> */}
        <FormItem title="备注">
          <TextField fullWidth value={form.remark} size="small" onChange={(e) => handleIptChange("remark", e.target.value)} rows={4} multiline />
        </FormItem>
        {/* {action != "pay" && (
          <FormItem title="排序" required>
            <TextField fullWidth placeholder="排序" type="number" autoComplete="off" id="order" value={form.order} size="small" onChange={(e) => handleIptChange("order", e.target.value)} />
          </FormItem>
        )} */}
        {/* {action != "pay" && (
          <FormItem title="是否显示" required>
            <RadioGroup row aria-label="gender" name="row-radio-buttons-group" value={form.isShow}>
              <FormControlLabel value={true} control={<Radio />} label="显示" onChange={(e) => handleIptChange("isShow", e.target.value)} />
              <FormControlLabel value={false} control={<Radio />} label="隐藏" onChange={(e) => handleIptChange("isShow", e.target.value)} />
            </RadioGroup>
          </FormItem>
        )} */}
      </FormDialog>
    </Page>
  );
}
